import {
  customInstance
} from "./chunk-PXAHF6KP.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/createWhatsappLead/createWhatsappLead.ts
var createWhatsappLead = async (listingId, whatsAppLeadRequest, apiConfig) => {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "createWhatsappLead");
    const data = await customInstance(
      {
        url: `/api/v1/listing/${listingId}/lead/whatsapp`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: whatsAppLeadRequest
      },
      _apiConfig
    );
    const redirectUrl = data.redirectUrl?.trim();
    if (!redirectUrl) {
      return getErrorResult(new Error("WhatsApp lead endpoint did not return a redirect URL"));
    }
    return {
      status: "success",
      data: redirectUrl
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
};

export {
  createWhatsappLead
};
